import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { StripeGenericPayForm } from './StripeGenericPayForm';
import { ProviderEnum } from '@/types/common';
import { AdyenPayForm } from './AdyenPayForm';
import { NuveiGeneralPayForm } from './NuveiGeneraPayForm';
import { PaymentMethodsToStripe } from '@/constants/stripe';
import { VenmoPayForm } from './VenmoPayForm';

export const GenericPayForm = ({ paymentMethod }: { paymentMethod: PaymentMethodEnum }) => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const provider = paymentMethodsSettings.find((pm) => pm.paymentMethodName === paymentMethod)?.provider;
  if (!provider) {
    throw new Error(`Provider for payment method ${paymentMethod} not found`);
  }
  if (provider === ProviderEnum.STRIPE) {
    return <StripeGenericPayForm paymentMethod={PaymentMethodsToStripe[paymentMethod as ExcludeOtherPaymentMethod]} />;
  }
  if (provider === ProviderEnum.ADYEN) {
    return <AdyenPayForm selectedPaymentMethod={paymentMethod} />;
  }
  if (provider === ProviderEnum.NUVEI) {
    return <NuveiGeneralPayForm />;
  }
  if (provider === ProviderEnum.BRAINTREE && paymentMethod === PaymentMethodEnum.VENMO) {
    return <VenmoPayForm />;
  }
  throw new Error(`Unsupported provider for payment method ${paymentMethod}: ${provider}`);
};
